import React from 'react'
import { Portal } from 'react-portal'
import './modal.sass'

export function Modal({ title, description, onClose, children, size = 'medium' }) {
  return (
    <Portal>
      <div className={`modal modal-${size}`}>
        <div className="modal-inner">
          <div className="modal-header">
            <div className="modal-header-content">
              <h4>{title}</h4>
              <p>{description}</p>
            </div>
            <div className="modal-header-close">
              <button onClick={e => e.preventDefault() & onClose()}>
                <i className="fa fa-times" />
              </button>
            </div>
          </div>
          <div className="modal-content">{children}</div>
        </div>
      </div>
    </Portal>
  )
}
